function createOptgroupDropdownFromPDF(items) {
  if (!Array.isArray(items)) {
    throw new TypeError(`createOptGroupDropDown expects an array. Got ${typeof items}`);
  }

  let sp = '';
  items.forEach((entry) => {
    const label = entry.cName;

    sp += `<optgroup label="${label}">`;
    if (entry.oSubMenu) {
      entry.oSubMenu.forEach((item) => {
        let disabled = '';

        if (typeof item.bEnabled !== 'undefined' && item.bEnabled === false) {
          disabled = ' disabled';
        }

        if (item.cName === '-') {
          sp += '<option disabled>──────────</option>';
        } else {
          sp += `<option value="${item.cReturn}"${disabled}>${item.cName}</option>`;
        }
      });
    }
    sp += '</optgroup>';
  });
  return sp;
}

module.exports = createOptgroupDropdownFromPDF;



// WEBPACK FOOTER //
// ./src/modules/pdf-popup-to-optgroup.js